<swiper #swiper [config]="settings">
  <ng-content></ng-content>
</swiper>
